import { CarouselNavButtonVariant } from './carousel-nav-buttons-props.interface';
import classNames from 'classnames';

interface CarouselNavButtonClassNameOptions {
  variant?: CarouselNavButtonVariant;
  disabled?: boolean;
  className?: string;
}

export const getCarouselNavButtonClassName = ({
  variant = 'bolder',
  disabled = false,
  className,
}: CarouselNavButtonClassNameOptions = {}) => {
  const isNeutralDefaultVariant = variant === 'neutralDefault';
  const isFloatingVariant = variant === 'floating';

  return classNames(
    'inline-flex shrink-0 items-center justify-center transition-[background-color,border-color,box-shadow,color,transform] duration-150 focus:outline-none focus:ring-2 focus:ring-offset-2',
    isFloatingVariant ? 'h-11 w-11 rounded-full' : 'h-9 w-9 rounded-xl',
    {
      'cursor-not-allowed': disabled,
      'border border-slate-300 bg-white/90 text-slate-400 shadow-[0_8px_20px_rgba(15,23,42,0.12)] focus:ring-slate-300':
        disabled && isFloatingVariant,
      'border-2 border-[#3f54a4] bg-white text-[#243b86] shadow-[0_12px_30px_rgba(15,23,42,0.28),0_0_0_4px_rgba(255,255,255,0.9)] hover:-translate-y-0.5 hover:border-[#243b86] hover:bg-[#f0f7ff] hover:text-[#18275f] hover:shadow-[0_16px_34px_rgba(15,23,42,0.32),0_0_0_4px_rgba(255,255,255,1)] active:translate-x-[1px] active:translate-y-[1px] active:shadow-[0_7px_18px_rgba(15,23,42,0.22),0_0_0_3px_rgba(255,255,255,0.95)] focus:ring-[#9cc6e8]':
        !disabled && isFloatingVariant,
      'bg-neutral-default-disabled text-slate-400 focus:ring-slate-200': disabled && isNeutralDefaultVariant,
      'bg-neutral-bolder-disabled text-slate-400 focus:ring-slate-200':
        disabled && !isNeutralDefaultVariant && !isFloatingVariant,
      'bg-neutral-default-enabled text-slate-800 shadow-[2px_2px_0px_0px_var(--neutral-9-18)] button-shadow-performance-fix active:translate-x-[2px] active:translate-y-[2px] active:shadow-none focus:ring-indigo-200':
        !disabled && isNeutralDefaultVariant,
      'bg-neutral-bolder-enabled text-slate-800 shadow-[2px_2px_0px_0px_var(--neutral-9-18)] button-shadow-performance-fix active:translate-x-[2px] active:translate-y-[2px] active:shadow-none focus:ring-indigo-200':
        !disabled && !isNeutralDefaultVariant && !isFloatingVariant,
    },
    className
  );
};

export const getCarouselNavIconClassName = (variant: CarouselNavButtonVariant = 'bolder', className?: string) =>
  classNames('shrink-0', variant === 'floating' ? 'h-6 w-6 stroke-[2.8]' : 'h-4 w-4', className);
